import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientFullModel } from 'hx-services';
import { NgIf } from '@angular/common';
import { HxClientEditComponent } from '../client-edit.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-client-edit-modal.m-grid__item.m-grid__item--fluid',
    templateUrl: './client-edit.modal.html',
    imports: [NgIf, HxClientEditComponent, TranslocoPipe]
})
export class HxClientEditModal {

  @Input() id!: number;

  constructor(
    public modalInstance: NgbActiveModal,
  ) {
  }

  onClientChanged(res?: ClientFullModel) {
    if (res) {
      this.modalInstance.close(res);
    } else {
      this.modalInstance.dismiss();
    }
  }
}
